type EventHandler = (event: any) => void;

export class EventEmitter {
    listenersByEvent: {
        [eventName: string]: EventHandler[];
    };

    constructor() {
        this.listenersByEvent = {};
    }

    public on(eventName: string, listener: EventHandler): EventEmitter {
        const listeners = this.listenersByEvent[eventName] || [];
        listeners.push(listener);
        this.listenersByEvent[eventName] = listeners;
        return this;
    }

    public off(eventName: string, listener: EventHandler): EventEmitter {
        const listeners = this.listenersByEvent[eventName] || [];
        this.listenersByEvent[eventName] = listeners.filter(l => l !== listener);
        return this;
    }

    public removeAllListeners() {
        this.listenersByEvent = {};
    }

    protected emit<T = undefined>(eventName: string, event?: T) {
        const listeners = this.listenersByEvent[eventName] || [];
        listeners.forEach(listener => {
            try {
                listener(event);
            }
            catch (err) {
                console.error(err);
            }
        });
    }
}
